import { useRef } from 'react';

import { DealTableCell } from '@crm/entities/deal';
import { useIsClamped } from '@crm/shared/lib/react';

import type { TLostDeal } from '@crm/entities/deal';

export const LostReasonCell = ({ lostReason }: { lostReason: TLostDeal['reason'] }) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const textContent = lostReason ?? '';
    const isClamped = useIsClamped(textRef);
    return (
        <DealTableCell isEmpty={!lostReason} className="px-1 flex items-center">
            <span
                ref={textRef}
                title={isClamped ? textContent : undefined}
                className="truncate font-normal text-xs "
            >
                {textContent}
            </span>
        </DealTableCell>
    );
};
